import { call, ForkEffect, put, takeLatest } from 'redux-saga/effects';
import { generalActions, IContactUsPayload } from './generalSlice';
import { sendContactUsMessage } from '../../api/generalApi';

function* watchSendContactUsMessage({ payload }: { payload: IContactUsPayload }) {
  try {
    yield put(generalActions.setComponentStatus({ isSubmitting: true }));
    yield call(sendContactUsMessage, payload);
    yield put(generalActions.setComponentStatus({ isSendMessageSuccess: true, isSubmitting: false }));
  } catch (error: any) {
    yield put(
      generalActions.setComponentStatus({
        isSendMessageSuccess: false,
        error: error.response.data.message,
        isSubmitting: false,
      }),
    );
  }
}

export function* watchGeneralSagas(): Generator<ForkEffect, void> {
  yield takeLatest(generalActions.sendContactUsMessage, watchSendContactUsMessage);
}

const generalSagas = watchGeneralSagas;
export default generalSagas;
